import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgParamDeclination = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Frame",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.0601 18.3639H18.3634V13.0606M18.3634 18.3639L5.63546 5.63603",
			stroke: "var(--stroke-0, #DFCBF5)",
			strokeOpacity: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	})
});
export default SvgParamDeclination;
